// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.stock-table__upper__controls {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}
.stock-table__upper__controls .p-inputgroup {
  width: 250px;
}
.stock-table__upper__controls__filter-button {
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.stock-table__upper__controls__filter-button.filters-active {
  background-color: #4F4BFF;
  color: white;
}

@media screen and (max-width: 768px) {
  .stock-table__upper {
    padding: 1rem;
    border-bottom: 1px solid #ECECEC;
  }
  .stock-table__upper__controls {
    width: 100%;
  }
  .stock-table__upper__controls .p-inputgroup {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/upper-controls/upper-controls.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AACR;AACQ;EACI,YAAA;AACZ;AAEQ;EACI,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAAZ;AAEY;EACI,yBAAA;EACA,YAAA;AAAhB;;AAMA;EACI;IACI,aAAA;IACA,gCAAA;EAHN;EAKM;IACI,WAAA;EAHV;EAKU;IACI,WAAA;EAHd;AACF","sourcesContent":[".stock-table__upper {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n\n    &__controls {\n        display: flex;\n        flex-direction: row;\n        gap: 0.5rem;\n        align-items: center;\n\n        .p-inputgroup {\n            width: 250px;\n        }\n\n        &__filter-button {\n            height: 40px;\n            background-color: transparent;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n\n            &.filters-active {\n                background-color: #4F4BFF;\n                color: white;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .stock-table__upper {\n        padding: 1rem;\n        border-bottom: 1px solid #ECECEC;\n        \n        &__controls {\n            width: 100%;\n            \n            .p-inputgroup {\n                width: 100%;\n            }\n        }\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
